import { EnumOption } from "./enum-option";

export const FNCategory = {
    EmploymentBased: 0,
    IndividualFamilyBased: 1,
    Investor: 2,
    Professional: 3,
    Student: 4,
    Others: 5
};

export const FNCategoryList: EnumOption[] = [
    { value: FNCategory.EmploymentBased, label: 'Employment Based' },
    { value: FNCategory.IndividualFamilyBased, label: 'Individual/Family Based' },
    { value: FNCategory.Investor, label: 'Investor' },
    { value: FNCategory.Professional, label: 'Professional' },
    { value: FNCategory.Student, label: 'Student' },
    { value: FNCategory.Others, label: 'Others' }
];